import React from 'react';
import './InfinityLoader.css';

const InfinityLoader = () => (
  <div className="infinity-loader-wrapper">
    <div className="infinity-loader">
      <svg viewBox="0 0 80 80">
        <circle id="test" cx="40" cy="40" r="32" />
      </svg>
    </div>
  </div>
);

export default InfinityLoader;
